import vdmDashboardReducers from "./reducers";
import vdmDashboardMiddleware from "./middlewares";

export { vdmDashboardMiddleware };
export default vdmDashboardReducers;
